const StatusWidget = ({ icon, label, value, testId }) => (
  <div
    className="bg-surface border border-border p-5 rounded-xl flex flex-col justify-between min-h-[110px] hover:border-aqua/40 transition-colors"
    data-testid={testId}
  >
    <div className="flex items-center justify-between text-aqua/80">
      <div className="text-aqua">{icon}</div>
    </div>
    <div className="mt-2">
      <div className="text-[10px] font-bold text-white/45 uppercase tracking-[0.25em]">
        {label}
      </div>
      <div className="mono font-mono text-base text-white mt-1.5 truncate">{value}</div>
    </div>
  </div>
);

export default StatusWidget;
